import { render } from "./BillingView.vue?vue&type=template&id=5053cbca&scoped=true&ts=true"
import script from "./BillingView.vue?vue&type=script&lang=ts"
export * from "./BillingView.vue?vue&type=script&lang=ts"

import "./BillingView.vue?vue&type=style&index=0&id=5053cbca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5053cbca"]])

export default __exports__